export default {
  name: null,
  pib: null,
  registration_number: null,
  status: null,
}
